import { useAppSelector } from '~/app/hooks'
import { USER_ROLE } from '~/constants/userRole'
import { selectAuth } from '~/redux/features'
import { CheckRole } from '~/utils/roleHelper'

// Return true if the current user has the ReadOnly role
export const useIsReadOnly = () => {
  const { roles } = useAppSelector(selectAuth)

  return CheckRole([USER_ROLE.READONLY], roles)
}
